/* -------------------------------------
 * Vinted theme tokens
 * ------------------------------------- */

/** Semantic wrapper kept for API consistency across DS */

/* -------------------------------------
 * Media size (enum → union + shim)
 * ------------------------------------- */

var MEDIA_SIZE_VALUES = ['x-small', 'small', 'regular', 'medium', 'large', 'x-large', 'x2-large', 'x3-large', 'x4-large', 'size-300', 'size-400', 'size-500', 'size-600', 'size-700', 'size-800', 'size-900', 'size-1000', 'size-1100', 'size-1200', 'size-1400', 'size-1600', 'size-2400', 'size-3200', 'size-4800'];
/**
 * @deprecated Use string literals instead, e.g. size="medium".
 * Kept for backward compatibility with enum-style usage.
 */
var MediaSizeValues = {
  XSmall: 'x-small',
  Small: 'small',
  Regular: 'regular',
  Medium: 'medium',
  Large: 'large',
  XLarge: 'x-large',
  X2Large: 'x2-large',
  X3Large: 'x3-large',
  X4Large: 'x4-large',
  Size300: 'size-300',
  Size400: 'size-400',
  Size500: 'size-500',
  Size600: 'size-600',
  Size700: 'size-700',
  Size800: 'size-800',
  Size900: 'size-900',
  Size1000: 'size-1000',
  Size1100: 'size-1100',
  Size1200: 'size-1200',
  Size1400: 'size-1400',
  Size1600: 'size-1600',
  Size2400: 'size-2400',
  Size3200: 'size-3200',
  Size4800: 'size-4800'
};

/* -------------------------------------
 * Typography: tags & variants
 * ------------------------------------- */

/** Allowed HTML tags for <Text> component */
var TEXT_TAG_VALUES = ['h1', 'h2', 'h3', 'h4', 'span'];
/**
 * @deprecated Prefer string literals (e.g. tag="h2") or use `TextVariant` with default mapping.
 * Kept for backward compatibility with enum-style usage.
 */
var TextTags = {
  HeadingXXL: 'h1',
  HeadingXL: 'h1',
  Heading: 'h1',
  SectionHeading: 'h2',
  Title: 'h2',
  Subtitle: 'h3',
  Caption: 'h4',
  Body: 'span',
  UserInput: 'span'
};

/** Semantic variants (style roles) for <Text> */
var TEXT_VARIANT_VALUES = ['headingXXL', 'headingXL', 'heading', 'sectionHeading', 'title', 'subtitle', 'caption', 'body', 'userInput'];
/** Default tag used per semantic variant */
var DEFAULT_TEXT_TAG_FOR_VARIANT = {
  headingXXL: 'h1',
  headingXL: 'h1',
  heading: 'h1',
  sectionHeading: 'h2',
  title: 'h2',
  subtitle: 'h3',
  caption: 'h4',
  body: 'span',
  userInput: 'span'
};

/* -------------------------------------
 * Layout & style unions (already unions)
 * Optionally expose VALUES arrays for controls/docs
 * ------------------------------------- */

var DIRECTION_VALUES = ['row', 'column'];

/* Temporary type for List until we unify Direction with Stack */

var DISTRIBUTION_VALUES = ['start', 'end', 'center', 'space-around', 'space-in-between', 'space-evenly'];
var ALIGNMENT_VALUES = ['top', 'center', 'bottom'];
var SELF_ALIGNMENT_VALUES = ['left', 'center', 'right'];
var BORDER_VALUES = ['none', 'default', 'active', 'inverse'];
var STYLE_VALUES = ['tight', 'narrow', 'default', 'wide'];
var OUTLINE_VALUES = ['none', 'default', 'round'];
var OVERFLOW_VALUES = ['auto', 'visible', 'hidden', 'clip'];
var OPACITY_VALUES = ['level-none', 'level-1', 'level-2', 'level-3', 'level-4', 'level-5', 'level-6', 'level-7', 'level-8', 'level-max'];

export { ALIGNMENT_VALUES, BORDER_VALUES, DEFAULT_TEXT_TAG_FOR_VARIANT, DIRECTION_VALUES, DISTRIBUTION_VALUES, MEDIA_SIZE_VALUES, MediaSizeValues, OPACITY_VALUES, OUTLINE_VALUES, OVERFLOW_VALUES, SELF_ALIGNMENT_VALUES, STYLE_VALUES, TEXT_TAG_VALUES, TEXT_VARIANT_VALUES, TextTags };
//# sourceMappingURL=types.js.map
